import { FC, useContext, useState } from 'react';

import { Button } from '@smartshell/ui-kit';

import { AuthContext } from 'auth';
import { FeatureHOC } from 'features';
import { LocalizationContext } from 'localization';
import { ManagerWarehouseModal } from 'modals';

import s from './Shop.module.scss';
import { ShopForm } from './ShopForm';

export const Shop: FC = () => {
  const { t } = useContext(LocalizationContext);
  const {
    data: { permissions },
  } = useContext(AuthContext);
  const [isWarehouseMWOpen, setIsWarehouseMWOpen] = useState(false);

  return (
    <div className={s.root}>
      {isWarehouseMWOpen && (
        <ManagerWarehouseModal
          onClose={() => setIsWarehouseMWOpen(false)}
          onlyAdd
        />
      )}

      {permissions?.has('good_manage_add') && (
        <div className={s.controls}>
          <FeatureHOC alias="stock_refill" strategy="disable" fullWidth={false}>
            <Button
              variant="outline"
              onClick={() => setIsWarehouseMWOpen(true)}
              iconName="BarCodeIcon"
            >
              {t('warehouse.add')}
            </Button>
          </FeatureHOC>
        </div>
      )}
      <ShopForm />
    </div>
  );
};
